import React from 'react';
import MsteamChannel from '../components/MSTeams/MsteamChannel';

const MSTeamsChannelPage = () => {
  return <MsteamChannel />;
};

export default MSTeamsChannelPage;
